/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Ai2 = ({ color = 'primary', aspectRatio = '756/240', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Ai2" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Ai2, Ai2 as default };
